import React from "react";
import { useLocation } from "react-router-dom";

import CachedIcon from "@mui/icons-material/Cached";
import { Button } from "@mui/material";
import { keyframes, styled } from "@mui/system";

import { useAutoUpdate } from "../../contexts/AutoUpdateContext";

const AutoReloadButton: React.FC = () => {
  const autoUpdate = useAutoUpdate();
  const location = useLocation();

  const isAutoReloadPage = (path: string) => {
    const isBackfill = path === "/backfill";
    const isJobs = path.startsWith("/jobs");
    return isBackfill || isJobs;
  };

  if (!isAutoReloadPage(location.pathname)) {
    return null;
  }

  const rotate = keyframes`
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(-360deg);
    }
  `;

  const RotateIcon = styled(CachedIcon, {
    shouldForwardProp: (prop) => prop !== "isRotating",
  })<{ isRotating: boolean }>(({ isRotating }) => ({
    animation: `${rotate} 2s linear infinite`,
    animationPlayState: isRotating ? "running" : "paused",
    transition: "opacity 0.3s ease-in-out",
  }));

  const handleClick = () => {
    autoUpdate.setActive(!autoUpdate.active);
  };

  return (
    <Button
      sx={{ color: "inherit" }}
      size="small"
      startIcon={<RotateIcon isRotating={autoUpdate.active} />}
      onClick={handleClick}
      data-testid="auto-update-button"
    >
      Auto Update
    </Button>
  );
};

export default AutoReloadButton;
